import type { DeltaTone } from '@/types';

export const classes = {
  pill: 'inline-flex items-center px-2 py-0.5 rounded-lg text-[11.5px] font-bold whitespace-nowrap',
  positive: 'bg-accent-positive/15 text-accent-positive',
  negative: 'bg-accent-negative/15 text-accent-negative',
  neutral: 'bg-taupe-1/15 text-taupe-1',
};

export function getToneClasses(tone: DeltaTone) {
  if (tone === 'positive') return classes.positive;
  if (tone === 'negative') return classes.negative;
  return classes.neutral;
}
